import React, { useState, useEffect } from "react";
import { Modal, Radio, InputNumber, Select, Row, Col, message } from "antd";
import { getSmartGridDefaults } from "../utils/batchPlacement";

const BatchPlacementModal = ({
  open,
  onClose,
  onConfirm,
  selectedCount,
  layoutType,
  dimensions,
}) => {
  const [pattern, setPattern] = useState("grid");
  const [gridParams, setGridParams] = useState({
    rows: 2,
    cols: 2,
    startX: 10,
    startY: 10,
    spacingX: 5,
    spacingY: 5,
  });
  const [lineParams, setLineParams] = useState({
    startX: 10,
    startY: 10,
    spacing: 5,
    direction: "horizontal",
    angle: 45,
  });
  const [evenParams] = useState({});
  const [fixedParams, setFixedParams] = useState({
    startPosition: 0,
    spacing: 5,
  });
  const [tunnelParams, setTunnelParams] = useState({
    startPosition: 0,
    spacing: 5,
    targetLane: "upper",
  });

  useEffect(() => {
    if (open && selectedCount > 0) {
      if (layoutType === "plane" && pattern === "grid") {
        const { rows, cols } = getSmartGridDefaults(selectedCount);
        setGridParams((prev) => ({ ...prev, rows, cols }));
      }
      if (layoutType === "line" && pattern === "fixed") {
        const smartSpacing = dimensions.width / (selectedCount + 1);
        setFixedParams((prev) => ({
          ...prev,
          spacing: Math.round(smartSpacing * 10) / 10,
        }));
      }
    }
  }, [open, selectedCount, layoutType, pattern, dimensions.width]);

  useEffect(() => {
    if (layoutType === "plane") {
      setPattern("grid");
    } else if (layoutType === "line") {
      setPattern("even");
    } else if (layoutType === "tunnel") {
      setPattern("alternating");
    }
  }, [layoutType]);

  const handleConfirm = () => {
    let params;
    if (layoutType === "plane") {
      params = pattern === "grid" ? gridParams : lineParams;
    } else if (layoutType === "line") {
      params = pattern === "even" ? evenParams : fixedParams;
    } else if (layoutType === "tunnel") {
      params = pattern === "custom" ? tunnelParams : {};
    }
    onConfirm(pattern, params);
  };

  return (
    <Modal
      title={`批次放置基站 (已選 ${selectedCount} 個)`}
      open={open}
      onCancel={onClose}
      onOk={handleConfirm}
      okText="確定放置"
      cancelText="取消"
      width={500}
    >
      <div style={{ paddingTop: 16 }}>
        {layoutType === "plane" ? (
          <Radio.Group
            value={pattern}
            onChange={(e) => setPattern(e.target.value)}
            style={{ width: "100%" }}
          >
            <div style={{ marginBottom: 24 }}>
              <Radio value="grid" style={{ fontWeight: 500, marginBottom: 12 }}>
                網格排列
              </Radio>
              {pattern === "grid" && (
                <div
                  style={{
                    marginLeft: 24,
                    padding: 12,
                    backgroundColor: "#fafafa",
                    borderRadius: 6,
                  }}
                >
                  <Row gutter={[12, 12]}>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>行數</div>
                      <InputNumber
                        min={1}
                        value={gridParams.rows}
                        onChange={(val) =>
                          setGridParams((prev) => ({ ...prev, rows: val || 1 }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>列數</div>
                      <InputNumber
                        min={1}
                        value={gridParams.cols}
                        onChange={(val) =>
                          setGridParams((prev) => ({ ...prev, cols: val || 1 }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>起點 X (m)</div>
                      <InputNumber
                        min={0}
                        max={dimensions.width}
                        value={gridParams.startX}
                        onChange={(val) =>
                          setGridParams((prev) => ({ ...prev, startX: val || 0 }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>起點 Y (m)</div>
                      <InputNumber
                        min={0}
                        max={dimensions.height}
                        value={gridParams.startY}
                        onChange={(val) =>
                          setGridParams((prev) => ({ ...prev, startY: val || 0 }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>
                        列間距 (m)
                      </div>
                      <InputNumber
                        min={0.1}
                        step={0.5}
                        value={gridParams.spacingX}
                        onChange={(val) =>
                          setGridParams((prev) => ({
                            ...prev,
                            spacingX: val || 0.1,
                          }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>
                        行間距 (m)
                      </div>
                      <InputNumber
                        min={0.1}
                        step={0.5}
                        value={gridParams.spacingY}
                        onChange={(val) =>
                          setGridParams((prev) => ({
                            ...prev,
                            spacingY: val || 0.1,
                          }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Row>
                </div>
              )}
            </div>

            <div style={{ marginBottom: 12 }}>
              <Radio value="line" style={{ fontWeight: 500, marginBottom: 12 }}>
                直線排列
              </Radio>
              {pattern === "line" && (
                <div
                  style={{
                    marginLeft: 24,
                    padding: 12,
                    backgroundColor: "#fafafa",
                    borderRadius: 6,
                  }}
                >
                  <Row gutter={[12, 12]}>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>起點 X (m)</div>
                      <InputNumber
                        min={0}
                        max={dimensions.width}
                        value={lineParams.startX}
                        onChange={(val) =>
                          setLineParams((prev) => ({ ...prev, startX: val || 0 }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>起點 Y (m)</div>
                      <InputNumber
                        min={0}
                        max={dimensions.height}
                        value={lineParams.startY}
                        onChange={(val) =>
                          setLineParams((prev) => ({ ...prev, startY: val || 0 }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col span={24}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>方向</div>
                      <Select
                        value={lineParams.direction}
                        onChange={(val) =>
                          setLineParams((prev) => ({ ...prev, direction: val }))
                        }
                        style={{ width: "100%" }}
                        options={[
                          { label: "水平", value: "horizontal" },
                          { label: "垂直", value: "vertical" },
                          { label: "斜向", value: "diagonal" },
                        ]}
                      />
                    </Col>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>間距 (m)</div>
                      <InputNumber
                        min={0.1}
                        step={0.5}
                        value={lineParams.spacing}
                        onChange={(val) =>
                          setLineParams((prev) => ({
                            ...prev,
                            spacing: val || 0.1,
                          }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                    {lineParams.direction === "diagonal" && (
                      <Col span={12}>
                        <div style={{ marginBottom: 4, fontSize: 12 }}>
                          角度 (°)
                        </div>
                        <InputNumber
                          min={0}
                          max={360}
                          value={lineParams.angle}
                          onChange={(val) =>
                            setLineParams((prev) => ({
                              ...prev,
                              angle: val || 0,
                            }))
                          }
                          style={{ width: "100%" }}
                        />
                      </Col>
                    )}
                  </Row>
                </div>
              )}
            </div>
          </Radio.Group>
        ) : layoutType === "line" ? (
          <Radio.Group
            value={pattern}
            onChange={(e) => setPattern(e.target.value)}
            style={{ width: "100%" }}
          >
            <div style={{ marginBottom: 24 }}>
              <Radio value="even" style={{ fontWeight: 500, marginBottom: 8 }}>
                均勻分佈
              </Radio>
              {pattern === "even" && (
                <div
                  style={{
                    marginLeft: 24,
                    padding: 12,
                    backgroundColor: "#fafafa",
                    borderRadius: 6,
                    fontSize: 13,
                    color: "#595959",
                  }}
                >
                  將所選基站均勻分佈在整條線上
                </div>
              )}
            </div>

            <div style={{ marginBottom: 12 }}>
              <Radio value="fixed" style={{ fontWeight: 500, marginBottom: 12 }}>
                固定間距
              </Radio>
              {pattern === "fixed" && (
                <div
                  style={{
                    marginLeft: 24,
                    padding: 12,
                    backgroundColor: "#fafafa",
                    borderRadius: 6,
                  }}
                >
                  <Row gutter={[12, 12]}>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>
                        起始位置 (m)
                      </div>
                      <InputNumber
                        min={0}
                        max={dimensions.width}
                        value={fixedParams.startPosition}
                        onChange={(val) =>
                          setFixedParams((prev) => ({
                            ...prev,
                            startPosition: val || 0,
                          }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>間距 (m)</div>
                      <InputNumber
                        min={0.1}
                        step={0.5}
                        value={fixedParams.spacing}
                        onChange={(val) =>
                          setFixedParams((prev) => ({
                            ...prev,
                            spacing: val || 0.1,
                          }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Radio.Group>
        ) : layoutType === "tunnel" ? (
          <Radio.Group
            value={pattern}
            onChange={(e) => setPattern(e.target.value)}
            style={{ width: "100%" }}
          >
            <div style={{ marginBottom: 24 }}>
              <Radio
                value="alternating"
                style={{ fontWeight: 500, marginBottom: 8 }}
              >
                交替排列 (上下交錯)
              </Radio>
              {pattern === "alternating" && (
                <div
                  style={{
                    marginLeft: 24,
                    padding: 12,
                    backgroundColor: "#fafafa",
                    borderRadius: 6,
                    fontSize: 13,
                    color: "#595959",
                  }}
                >
                  將基站在上下兩線道間交替排列，達到最均勻分佈
                </div>
              )}
            </div>

            <div style={{ marginBottom: 24 }}>
              <Radio
                value="fill-upper-first"
                style={{ fontWeight: 500, marginBottom: 8 }}
              >
                優先填充上線道
              </Radio>
              {pattern === "fill-upper-first" && (
                <div
                  style={{
                    marginLeft: 24,
                    padding: 12,
                    backgroundColor: "#fafafa",
                    borderRadius: 6,
                    fontSize: 13,
                    color: "#595959",
                  }}
                >
                  先將基站依序放置在上線道，填滿後再填充下線道
                </div>
              )}
            </div>

            <div style={{ marginBottom: 24 }}>
              <Radio
                value="even-both"
                style={{ fontWeight: 500, marginBottom: 8 }}
              >
                兩線道均勻分佈
              </Radio>
              {pattern === "even-both" && (
                <div
                  style={{
                    marginLeft: 24,
                    padding: 12,
                    backgroundColor: "#fafafa",
                    borderRadius: 6,
                    fontSize: 13,
                    color: "#595959",
                  }}
                >
                  將基站平均分配到上下線道，每條線道內均勻分佈
                </div>
              )}
            </div>

            <div style={{ marginBottom: 12 }}>
              <Radio value="custom" style={{ fontWeight: 500, marginBottom: 12 }}>
                自訂排列
              </Radio>
              {pattern === "custom" && (
                <div
                  style={{
                    marginLeft: 24,
                    padding: 12,
                    backgroundColor: "#fafafa",
                    borderRadius: 6,
                  }}
                >
                  <Row gutter={[12, 12]}>
                    <Col span={24}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>
                        目標線道
                      </div>
                      <Select
                        value={tunnelParams.targetLane}
                        onChange={(val) =>
                          setTunnelParams((prev) => ({
                            ...prev,
                            targetLane: val,
                          }))
                        }
                        style={{ width: "100%" }}
                        options={[
                          { label: "上線道", value: "upper" },
                          { label: "下線道", value: "lower" },
                        ]}
                      />
                    </Col>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>
                        起始位置 (m)
                      </div>
                      <InputNumber
                        min={0}
                        max={dimensions.width}
                        value={tunnelParams.startPosition}
                        onChange={(val) =>
                          setTunnelParams((prev) => ({
                            ...prev,
                            startPosition: val || 0,
                          }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col span={12}>
                      <div style={{ marginBottom: 4, fontSize: 12 }}>間距 (m)</div>
                      <InputNumber
                        min={0.1}
                        step={0.5}
                        value={tunnelParams.spacing}
                        onChange={(val) =>
                          setTunnelParams((prev) => ({
                            ...prev,
                            spacing: val || 0.1,
                          }))
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Radio.Group>
        ) : null}
      </div>
    </Modal>
  );
};

export default BatchPlacementModal;

